import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function TopLists() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Explore curated top lists of airports on First-Class.com. Find the best airports for premium travel and exceptional passenger experiences'
          }
        />
        <title>Airport Toplists: Ranking the Best Airports Worldwide</title>
      </Head>
      <ArticlesList
        subtype="Toplists"
        type="Airports"
        heading="Finest Selection"
      />
    </>
  );
}

export default withLayout(TopLists, true);
